import { useLocation, NavLink } from "react-router-dom";
import home from "../../../assets/home.svg";
import scan from "../../../assets/scan.svg";
import manual from "../../../assets/manual.svg";
import stock_reports from "../../../assets/stock_reports.svg";
import INVOICE from "../../../assets/InvoiceIcon.svg";
import "./Sidebar.css";

const Sidebar = ({ className }) => {
  // const { setIsFormOpen } = useContext(FormContext);

  const location = useLocation();

  const currentPath = location.pathname;
  // const closeFormHandler = () => {
  //   setIsFormOpen(false);
  // };

  return (
    <aside>
      <nav
        className={
          currentPath === "/operator"
            ? "sidebar-operator-home"
            : "sidebar-manual-entry"
        }
      >
        <ul className="nav-list">
          <li className="sidebar-list-item">
            <NavLink
              to="/operator"
              className={({ isActive }) => (isActive ? "link active" : "link")}
            >
              <img src={home} className="img img-home" alt="" />
              <p className="desc">Home</p>
            </NavLink>
          </li>
          <li className="sidebar-list-item">
            <NavLink
              to="/scan"
              className={({ isActive }) => (isActive ? "link active" : "link")}
            >
              <img src={scan} className="img img-scan" alt="" />
              <p className="desc desc-scan">
                Scan
                <br /> Claim
              </p>
            </NavLink>
          </li>
          <li className="sidebar-list-item">
            <NavLink
              to="/manual-entry"
              className={({ isActive }) => (isActive ? "link active" : "link")}
            >
              <img src={manual} className="img img-manual" alt="" />
              <p className="desc desc-manual">
                Manual
                <br /> Entry
              </p>
            </NavLink>
          </li>
          <li className="sidebar-list-item">
            <NavLink
              to="/stockist-report"
              className={({ isActive }) => (isActive ? "link active" : "link")}
            >
              <img src={stock_reports} className="img img-reports" alt="" />
              <p className="desc desc-reports">
                Stockist
                <br /> Report
              </p>
            </NavLink>
          </li>
          <li className="sidebar-list-item">
            <NavLink
              to="/invoice-page"
              className={({ isActive }) => (isActive ? "link active" : "link")}
            >
              <img src={INVOICE} className="img img-reports" alt="" />
              <p className="desc desc-reports">
                Invoice
                <br />
              </p>
            </NavLink>
          </li>
        </ul>
      </nav>
    </aside>
  );
};

export default Sidebar;
